import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  height: 300,
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    boxSizing: 'border-box',
    padding: theme.spacing(0, 2),
    width: 350,
  },
}));
